import React from "react";
import token from "../../img/tokenNew.webp";
import styles from "./NoPlants.module.scss";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const NoPlants = () => {
  const { t } = useTranslation();
  return (
    <div className={styles.noplants}>
      <picture>
        <source srcSet={token} type="image/webp" />
        <img src={token} alt="plant" className={styles.noplants__plant} />
      </picture>
      <div className={styles.noplants__text}>
        {t("You have not purchased any tokens yet")}
      </div>
      <Link
        state={{ from: window.location.pathname }}
        to={"/buy"}
        className={styles.noplants__button}
      >
        {t("Buy tokens")}
      </Link>
    </div>
  );
};

export default NoPlants;
